import { render } from "./ProcessTemplateSubNav.vue?vue&type=template&id=87b2a846&ts=true"
import script from "./ProcessTemplateSubNav.vue?vue&type=script&lang=ts"
export * from "./ProcessTemplateSubNav.vue?vue&type=script&lang=ts"

import "./ProcessTemplateSubNav.vue?vue&type=style&index=0&id=87b2a846&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__